import { VStack } from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import { BorrowingBaseReportGQLType } from 'types/dashboard-core-gqlTypes.generated';

import { BorrowingBaseSummaryCash } from './BorrowingBaseSummaryCash';
import { BorrowingBaseSummaryFacilitySummary } from './BorrowingBaseSummaryFacilitySummary';
import { BorrowingBaseSummaryFinalBorrowingBaseReport } from './BorrowingBaseSummaryFinalBorrowingBaseReport';
import { BorrowingBaseSummaryReceivables } from './BorrowingBaseSummaryReceivables';
import { BorrowingBaseSummarySections } from './utils';

type BorrowingBaseSummaryWithSingleValueProps = {
  sections: BorrowingBaseSummarySections[];
  borrowingBaseReport: BorrowingBaseReportGQLType;
  creditAgreement: CreditAgreement.DomainEntity.CreditAgreementFullArtifact;
};
export const BorrowingBaseSummaryWithSingleValue = ({
  sections,
  borrowingBaseReport,
  creditAgreement,
}: BorrowingBaseSummaryWithSingleValueProps) => {
  const includesSection = (section: BorrowingBaseSummarySections) =>
    _.includes(sections, section);

  const showComparisonAndDifferenceColumns = false;

  return (
    <VStack mb="24px" spacing="32px" w="100%">
      {includesSection(BorrowingBaseSummarySections.facilitySummary) && (
        <BorrowingBaseSummaryFacilitySummary
          borrowingBaseReports={{
            minuendBorrowingBaseReport: borrowingBaseReport,
          }}
          showComparisonAndDifferenceColumns={
            showComparisonAndDifferenceColumns
          }
        />
      )}
      {includesSection(BorrowingBaseSummarySections.receivables) && (
        <BorrowingBaseSummaryReceivables
          borrowingBaseReports={{
            minuendBorrowingBaseReport: borrowingBaseReport,
          }}
          creditAgreement={creditAgreement}
          showComparisonAndDifferenceColumns={
            showComparisonAndDifferenceColumns
          }
        />
      )}
      {includesSection(BorrowingBaseSummarySections.cash) && (
        <BorrowingBaseSummaryCash
          borrowingBaseReports={{
            minuendBorrowingBaseReport: borrowingBaseReport,
          }}
          creditAgreement={creditAgreement}
          showComparisonAndDifferenceColumns={
            showComparisonAndDifferenceColumns
          }
        />
      )}
      {includesSection(
        BorrowingBaseSummarySections.finalBorrowingBaseReport,
      ) && (
        <BorrowingBaseSummaryFinalBorrowingBaseReport
          borrowingBaseReports={{
            minuendBorrowingBaseReport: borrowingBaseReport,
          }}
          showComparisonAndDifferenceColumns={
            showComparisonAndDifferenceColumns
          }
        />
      )}
    </VStack>
  );
};
